import { useSettingsStore } from '../store/settingsStore';
import { translations } from '../i18n/translations';

/**
 * Returns a `t(key)` translator function for the current language.
 * Falls back to English when a key is missing.
 */
export function useT() {
  const language = useSettingsStore((s) => s.language);
  return (key) => translations[language]?.[key] ?? translations.en[key] ?? key;
}
